import { Modal } from 'antd'
import styled from 'styled-components'

const HyModal = styled(Modal)`
  &&& {
    .ant-modal-header {
      height: 38px;
      background-color: #F6F7F8;
      padding: 0 14px;
      display: flex;
      align-items: center;
      border-bottom: none;
      border-radius: 6px 6px 0 0;
    }
    .ant-modal-title {
      color: #666;
      font-size: 12px;
    }

    .ant-modal-close {
      top: 9px;
      right: 14px;
    }

    .ant-modal-close-x {
      width: 16px;
      height: 16px;
      line-height: 16px;
      svg { width: 12px; height: 12px; }
    }

    .ant-modal-body {
      padding: 24px 20px;
    }
  }
`

export default HyModal
